import { WrapRootElementNodeArgs } from 'gatsby';
import PageProvider from './src/PageProvider';
import '@fontsource/lato';
import '@fontsource/caveat';
import React from 'react';

export const wrapRootElement = ({ element }: WrapRootElementNodeArgs): React.ReactElement => {
  return <PageProvider>{element}</PageProvider>;
};
